var _circle, _path, _mask, _path2, _mask2, _path3, _path4, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartinline = function SvgStartinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "#19FB9B",
    fillOpacity: 0.2,
    stroke: "#19FB9B",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#19FB9B",
    strokeLinejoin: "round",
    d: "M12.5 9c0 2.432-.44 4.61-1.129 6.16-.344.777-.742 1.374-1.159 1.77-.414.394-.822.57-1.212.57s-.798-.176-1.212-.57c-.417-.396-.815-.993-1.16-1.77C5.94 13.61 5.5 11.433 5.5 9s.44-4.61 1.128-6.16c.345-.777.743-1.374 1.16-1.77C8.202.675 8.61.5 9 .5s.798.176 1.212.57c.417.396.815.993 1.16 1.77C12.06 4.39 12.5 6.567 12.5 9Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "learn-start-1",
    width: 6,
    height: 4,
    x: 3,
    y: 2,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 2h6v4H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5a2 2 0 1 1 4 0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#063321",
    strokeLinejoin: "round",
    d: "M4 5a2 2 0 1 1 4 0z",
    mask: "url(#learn-start-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "learn-start-2",
    width: 6,
    height: 4,
    x: 9,
    y: 12,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 12h6v4H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13a2 2 0 1 1-4 0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#063321",
    strokeLinejoin: "round",
    d: "M14 13a2 2 0 1 1-4 0z",
    mask: "url(#learn-start-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#19FB9B",
    strokeLinejoin: "round",
    d: "M.5 9h17"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 1.5,
    fill: "#063321",
    stroke: "#19FB9B",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 1.5,
    fill: "#063321",
    stroke: "#19FB9B",
    strokeLinejoin: "round"
  })));
};
export default SvgStartinline;